import React, { Component } from 'react';

class ToolTip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    }
  }

  showToolTip = () => {
    this.setState({ show: true })
  }

  hideToolTip = () => {
    this.setState({ show: false });
  }

  render() {
    let { position, message, className } = this.props;
    if (message && this.props.children) {
      position = position ? position : "right";
      return (
        <span className={`cw-tooltip ${className ? className : ''}`} onMouseLeave={this.hideToolTip} >
          {this.state.show &&
            <div className={`tooltip-message-container tooltip-${position}`}>
              <div className="tooltip-message">{this.props.message}</div>
            </div>
          }
          <span className="tooltip-trigger" onMouseEnter={this.showToolTip}>{this.props.children}</span>
        </span>
      )
    }
    return null;
  }
}

export default ToolTip
